import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { graphql, StaticQuery } from 'gatsby'
import { stripIndent } from 'common-tags/es'
import aitoDataSource from '../../../assets/aito-data-source.svg'
import * as styles from './styles'
import dashLine from '../../../assets/dash-line.svg'
import { Section, Button, AnimatedWindowStack, CodeSnippet } from '..'

const propTypes = {
  data: PropTypes.object.isRequired
}

const searchQuery = stripIndent`
    {
      {
        "from": "project_status",
        "where": {
          "category": "technology",
          "duration": {"$numeric": 28},
          "goal": {"$numeric": 60000}
        },
        "predict": "reaches_goal"
      }
    }
    `
const queryResult = stripIndent`
    {
      "$p": 0.8669790673789294,
      "feature": "success",
      "$why": {
        "factors": [
          {"type": "baseP", "value": 0.5824108373535493},
          {"variable": "goal in [50000.0, 69950.0]", "value": 0.6284269431801215},
          {"variable": "category:technology", "value": 1.5290631512213575},
          {"variable": "duration in [28.0, 28.0]", "value": 1.2528286824463164}
        ]
      }
    }
    `

const WorkFlow = ({ data }) => {
  const button = (
    <styles.StyledLink href="https://funding-demo.aito.ai/" target="_blank" noopener noreferrer>
      <Button size="small">
        {data.buttonText}
      </Button>
    </styles.StyledLink>
  )

  return (
    <styles.WorkflowContainer>
      <styles.SectionContainer>
        <styles.SectionRow>
          <styles.SectionCol sm={1} xs={0} />
          <styles.SectionCol sm={5} xs={12}>
            <styles.SectionSmallHeader>
              {data.workflowHeader}
            </styles.SectionSmallHeader>
          </styles.SectionCol>
        </styles.SectionRow>

        <Section>
          <styles.StepRow>
            <styles.SectionCol sm={1} xs={0} />
            <styles.SectionCol sm={5} xs={12}>
              <styles.StepSmallHeader>
                {data.step1SmallHeader}
              </styles.StepSmallHeader>
              <styles.StepBigHeader>
                {data.step1BigHeader}
              </styles.StepBigHeader>
              <styles.StepText>
                {data.step1Text}
              </styles.StepText>
            </styles.SectionCol>
            <styles.SectionCol sm={1} xs={0} />
            <styles.SectionCol sm={5} xs={12}>
              <styles.DataSourceImage src={aitoDataSource} alt="" />
            </styles.SectionCol>
          </styles.StepRow>

          <styles.DashLineContainer>
            <styles.DashLine src={dashLine} alt="" />
          </styles.DashLineContainer>

          <styles.StepRow reverse>
            <styles.SectionCol sm={5} xs={12}>
              <styles.StepSmallHeader>
                {data.step2SmallHeader}
              </styles.StepSmallHeader>
              <styles.StepBigHeader>
                {data.step2BigHeader}
              </styles.StepBigHeader>
              <styles.StepText>
                {data.step2Text}
              </styles.StepText>
            </styles.SectionCol>
            <styles.SectionCol sm={1} xs={0} />
            <styles.SectionCol sm={5} xs={12}>
              <styles.QueryContainer>
                <styles.QueryHeader>
                  {data.step2QueryHeader}
                </styles.QueryHeader>
                <styles.QueryBox>
                  <CodeSnippet language="javascript">
                    {searchQuery}
                  </CodeSnippet>
                </styles.QueryBox>
                <styles.QueryHeader>
                  {data.step2QueryHeaderResult}
                </styles.QueryHeader>
                <styles.QueryBox>
                  <CodeSnippet language="javascript">
                    {queryResult}
                  </CodeSnippet>
                </styles.QueryBox>
              </styles.QueryContainer>
            </styles.SectionCol>
            <styles.SectionCol sm={1} xs={0} />
          </styles.StepRow>

          <styles.DashLineContainer>
            <styles.DashLineReverse src={dashLine} alt="" />
          </styles.DashLineContainer>

          <styles.StepRow>
            <styles.SectionCol sm={1} xs={0} />
            <styles.SectionCol sm={5} xs={12}>
              <styles.StepSmallHeader>
                {data.step3SmallHeader}
              </styles.StepSmallHeader>
              <styles.StepBigHeader>
                {data.step3BigHeader}
              </styles.StepBigHeader>
              <styles.StepText>
                {data.step3Text}
              </styles.StepText>

              <styles.ButtonContainerDesktop>
                {button}
              </styles.ButtonContainerDesktop>
            </styles.SectionCol>
            <styles.SectionCol sm={1} xs={0} />
            <styles.SectionCol sm={5} xs={12}>
              <AnimatedWindowStack
                indicator={data.indicator}
                searchFormContent={data.searchForm}
                kickstarterFrontEndContent={data.kickstarterFrontEnd}
              />
            </styles.SectionCol>
          </styles.StepRow>
        </Section>
        <styles.ButtonContainerMobile>
          {button}
        </styles.ButtonContainerMobile>
      </styles.SectionContainer>
    </styles.WorkflowContainer>
  )
}

WorkFlow.propTypes = propTypes

export default () => (
  <StaticQuery
    query={graphql`
      query GetWorkflow {
        allYaml(filter: {file: {eq: "workflow"}}) {
          edges {
            node {
              workflowHeader
              step1SmallHeader
              step1BigHeader
              step1Text

              step2SmallHeader
              step2BigHeader
              step2Text
              step2QueryHeader
              step2QueryHeaderResult

              step3SmallHeader
              step3BigHeader
              step3Text

              buttonText

              indicator {
                frontend
                backend
              }
              
              kickstarterFrontEnd {
                header1
                label1
                categoryInput
                label2
                durationInput
                label3
                goalInput
                header2
                probabilityText
              }
            }
          }
        }
      }
    `
    }
    render={(data) => {
      const { allYaml } = data
      const { edges } = allYaml
      const { node } = _.first(edges)
      return (
        <WorkFlow data={node} />
      )
    }}
  />
)
